import { render, staticRenderFns } from "./CommentsDynamic.vue?vue&type=template&id=ad31c248&scoped=true"
import script from "./CommentsDynamic.vue?vue&type=script&lang=js"
export * from "./CommentsDynamic.vue?vue&type=script&lang=js"
import style0 from "./CommentsDynamic.vue?vue&type=style&index=0&id=ad31c248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad31c248",
  null
  
)

export default component.exports